export default __webpack_public_path__ + "static/media/icon_512.288aac9e.png";